export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/identification_perseus/go_main.81122d6.png";